/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeesEmployeesEmployee } from './employees-employees-employee';

/**
 * Candidate for the position of a position request
 */
export interface PositionRequestCandidate {
  /**
   * Type of candidate: external or internal
   */
  type?: PositionRequestCandidateTypeEnum;
  /**
   * Possible employee id of candidate
   */
  employeeId?: string | null;
  employee?: EmployeesEmployeesEmployee;
  /**
   * Possible full name of candidate
   */
  fullName?: string | null;
  /**
   * Possible gid of candidate
   */
  gid?: string | null;
}
export enum PositionRequestCandidateTypeEnum {
  Internal = 'Internal',
  External = 'External'
}
